import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';
import { ELEVES_VIEWS_KEY } from '@teetsh/app/src/queries/eleves/views/useElevesViews';

function createEleveView(props: {
  schoolyearId: string;
  schoolId: string;
  viewId: string;
  viewName: string;
}) {
  const requestURL = `/schoolyears/${props.schoolyearId}/schools/${props.schoolId}/eleves-views`;
  return request(requestURL, {
    method: 'POST',
    body: {
      id: props.viewId,
      name: props.viewName,
    },
  });
}

export default function useCreateElevesView() {
  const { schoolyear, school } = useSchoolSchoolyear();
  const queryClient = useQueryClient();

  const { mutateAsync } = useMutation({
    mutationFn: (p: { viewId: string; viewName: string }) =>
      createEleveView({
        schoolyearId: schoolyear.id,
        schoolId: school.id,
        viewId: p.viewId,
        viewName: p.viewName,
      }),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [ELEVES_VIEWS_KEY],
      });
    },
  });
  return mutateAsync;
}
